import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CustomizeBoundaryFillsContainer, type CustomizeBoundaryFillsContainerProps,
} from './customizeBoundaryFills.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryCustomizeFills: CustomizeBoundaryFillsContainerProps;
  }
}
modalRenderer.register('BoundaryCustomizeFills', CustomizeBoundaryFillsContainer);
